module.exports = __webpack_public_path__ + "static/media/operational.36cfe61e.jpg";